import React from 'react';
import {Button, Modal} from '@themesberg/react-bootstrap';
import {FormattedMessage} from 'react-intl';
import {Map, Marker, TileLayer, useLeaflet} from 'react-leaflet';

export default (props) => {
  const {title, coords, showMapModal, setShowMapModal, setCoords} = props;

  const parseCoords = (str) => {
    if (str) {
      const coordsAndZoom = str.split('/');
      const split = coordsAndZoom[0].split(',');
      return {
        position: [parseFloat(split[0]), parseFloat(split[1])],
        zoom: parseInt(coordsAndZoom[1], 10)
      };
    }
    return {position: [46.41, 2.05], zoom: 5};
  };

  const mapRef = React.useRef(null);
  // Vue initiale figée le temps d'une ouverture : ne pas la lier à la position
  // du marqueur, sinon chaque clic recentrerait la carte.
  const [view, setView] = React.useState(parseCoords(coords));
  const [position, setPosition] = React.useState(parseCoords(coords).position);

  React.useEffect(() => {
    if (showMapModal) {
      const parsed = parseCoords(coords);
      setView(parsed);
      setPosition(parsed.position);
    }
  }, [showMapModal]);

  const ResizeMap = () => {
    const leaflet = useLeaflet();
    leaflet.map.invalidateSize();
    return null;
  };

  const handleMapClick = (e) => {
    setPosition([e.latlng.lat, e.latlng.lng]);
  };

  const handleMarkerDragEnd = (e) => {
    const latlng = e.target.getLatLng();
    setPosition([latlng.lat, latlng.lng]);
  };

  const handleValid = () => {
    const lat = Math.round(position[0] * 1e6) / 1e6;
    const lng = Math.round(position[1] * 1e6) / 1e6;
    const zoom = mapRef.current ? mapRef.current.leafletElement.getZoom() : view.zoom;
    setCoords(lat + ',' + lng + '/' + zoom);
    setShowMapModal(false);
  };

  return (
    <Modal as={Modal.Dialog} centered show={showMapModal} onHide={() => setShowMapModal(false)}>
      <Modal.Header>
        <Modal.Title className="h6">{title}</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={() => setShowMapModal(false)}/>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2"><FormattedMessage id="CENTER_MAP_HINT"/></p>
        <Map ref={mapRef} center={view.position} zoom={view.zoom} scrollWheelZoom={true}
             onClick={handleMapClick} style={{width: '100%', height: '500px'}}>
          <ResizeMap/>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position} draggable={true} onDragend={handleMarkerDragEnd}/>
        </Map>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleValid}>
          <FormattedMessage id="VALID"/>
        </Button>
        <Button variant="link" className="text-gray ms-auto" onClick={() => setShowMapModal(false)}>
          <FormattedMessage id="CLOSE"/>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
